import { useEffect, useState } from "react";
import { getResearchQueryRunScoringConfigById } from "../services/scoringService";

const useFetchResearchQueryRunScoringConfigById = ({
  setIsLoading,
  configId,
}: any) => {
  const [configData, setConfigData] = useState<any>({});

  useEffect(() => {
    if (configId && configId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getResearchQueryRunScoringConfigById(configId);
          // Guard against undefined/null so we never overwrite valid state with nothing.
          if (result) {
            setConfigData(result);
          }
        } catch (err) {
          setConfigData({});
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [configId]); // eslint-disable-line react-hooks/exhaustive-deps

  return [configData];
};

export default useFetchResearchQueryRunScoringConfigById;
